document.addEventListener('DOMContentLoaded', ()=> {
    let headerSticky = document.querySelector('.header');
    if(headerSticky) {
        document.addEventListener("scroll", (e) => {
            if (window.pageYOffset >= 20) {
                headerSticky.classList.add('_sticky');
                if(document.location.pathname === '/') {
                    document.body.classList.remove('_white');
                }
            } else {
                headerSticky.classList.remove('_sticky');
                if(document.location.pathname === '/') {
                    document.body.classList.add('_white');
                }
            }
        });
    }
})

